export default __webpack_public_path__ + "static/koinno-bg-e8d712300184c3000891d9bafdd586d0.jpg";